import {
  Flex,
  Icon,
  IconButton,
  Input,
  InputGroup,
  InputRightElement,
} from '@chakra-ui/react'
import React from 'react'
import IconPhoneTransfer from '~/assets/svgs/icon-phone-transfer.svg?react'

import { cleanDialstring, toMaskedPhoneNumber } from '@mangovoice/core'

import {
  TransferHeaderVariants,
  useTransferHeaderStyle,
} from './componentStyles/TransferHeader.style'

interface TransferHeaderProps {
  transferTarget: string
  onTransferTargetChange: (target: string) => void
  onTransfer: (target: string) => void
}
export const TransferHeader = ({
  transferTarget,
  onTransferTargetChange,
  onTransfer,
}: TransferHeaderProps) => {
  const isTransferAvailable = transferTarget.length >= 3
  const variant = isTransferAvailable
    ? TransferHeaderVariants.Default
    : TransferHeaderVariants.Disabled

  const handleTransferTargetChange = (
    e: React.ChangeEvent<HTMLInputElement>,
  ) => {
    onTransferTargetChange(toMaskedPhoneNumber(e.target.value))
  }
  const handleTransfer = () => {
    if (!isTransferAvailable) {
      return
    }
    onTransfer(cleanDialstring(transferTarget))
  }

  const styles = useTransferHeaderStyle({ variant })

  return (
    <Flex sx={styles.container}>
      <InputGroup>
        <Input
          sx={styles.input}
          variant="outline"
          placeholder="Enter Number"
          value={transferTarget}
          onChange={handleTransferTargetChange}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              handleTransfer()
            }
          }}
        ></Input>
        <InputRightElement sx={styles.inputRightElement}>
          <IconButton
            sx={styles.iconButton}
            onClick={handleTransfer}
            aria-label="Transfer"
          >
            <Icon as={IconPhoneTransfer} sx={styles.icon} />
          </IconButton>
        </InputRightElement>
      </InputGroup>
    </Flex>
  )
}
